/** Euclidean distance threshold for considering two face descriptors as the same person */
export const DESCRIPTOR_THRESHOLD = 0.6;

/** Fraction of indicator ring that must be filled to complete the head-rotation phase (0-1) */
export const COMPLETION_THRESHOLD = 0.95;

/** Angular proximity in degrees for matching head angle to indicator segment */
export const ANGLE_PROXIMITY = 28;

/**
 * Minimum angular distance (degrees) between detections before adding a new one.
 * Prevents noise/jitter from filling the circle with slight movements.
 * Lower = denser coverage (fewer gaps), higher = requires more deliberate rotation.
 */
export const MIN_ANGLE_STEP = 10;

/** Smile probability above this is considered "smiling" */
export const SMILE_THRESHOLD = 0.5;

/** Minimum age to pass verification */
export const AGE_THRESHOLD = 16;

export const GOOGLENET_SIZE = 224;
export const GOOGLENET_LABELS = [
  "0-2",
  "4-6",
  "8-12",
  "15-20",
  "25-32",
  "38-43",
  "48-53",
  "60-100",
] as const;
export const GOOGLENET_MEAN: [number, number, number] = [123, 117, 104];

/** First bucket index where age >= 21 (i.e. "25-32") */
export const ADULT_MIN_BUCKET_INDEX = 4;

/** Seconds without face detection before resetting the flow */
export const NO_DETECTION_TIMEOUT_MS = 6000;

/** Detector input size: smaller for mobile (faster), larger for desktop (more accurate) */
export const DETECTOR_INPUT_SIZE_MOBILE = 256;
export const DETECTOR_INPUT_SIZE_DESKTOP = 512;

export const DETECTOR_SCORE_THRESHOLD = 0.5;

export const RING_SEGMENTS_COUNT = 74;

export const MAX_FAILURE_ATTEMPTS = 5;
